export default "__VITE_ASSET__CZsibtD2__"